export default {
  Produtos: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "produtos"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Produtos.js
// module id = TwM5
// module chunks = 18